import { type MouseEvent } from 'react'

import bannedImg from '@/assets/images/banned.webp'
import unofficialImg from '@/assets/images/unofficial.webp'
import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { type InViewStatus } from '@/hooks/useInView'

import styles from './CardFace.module.scss'
import { CardFaceWarning } from './CardFaceWarning/CardFaceWarning'

type Props = {
  hasContentWarning?: boolean
  hasError?: boolean
  image?: string
  inViewStatus?: InViewStatus
  isBanned?: boolean
  isUnofficial?: boolean
  linkProps?: {
    href: string
    newTab?: boolean
  }
  loading?: boolean
  name?: string
  onClick?: (e: MouseEvent<HTMLElement>) => void
}

export const CardFace = ({
  hasContentWarning,
  hasError,
  image,
  inViewStatus = 'inView',
  isBanned,
  isUnofficial,
  linkProps,
  loading: _,
  name,
  onClick: onClickProp,
}: Props) => {
  const Element = linkProps?.href ? LinkRoute : 'div'
  const onClick = linkProps?.href ? onClickProp : undefined
  return (
    <Element className={styles.container} onClick={onClick} {...linkProps}>
      {inViewStatus !== 'outside' && image && (
        <img alt='' className={styles.image} decoding='async' role='presentation' src={image} />
      )}
      <span className={styles.name}>{name || 'Card Name'}</span>
      {isBanned ? (
        <span className={styles.banned}>
          <img alt='Banned' decoding='async' loading='lazy' src={bannedImg.src} />
        </span>
      ) : (
        isUnofficial && (
          <span className={styles.unofficial}>
            <img alt='Unofficial' decoding='async' loading='lazy' src={unofficialImg.src} />
          </span>
        )
      )}
      {hasContentWarning && <CardFaceWarning />}
      {hasError && (
        <span className={styles.error}>
          <Icon name='ban' />
          <span className={styles.errorTitle}>Error</span>
          <span>We had trouble loading this card, try refreshing the page.</span>
        </span>
      )}
    </Element>
  )
}
